import { useEffect, RefObject } from 'react';

/**
 * Custom hook that detects clicks outside of specified elements and calls a handler
 * @param refs - Array of refs to elements that should not trigger the outside click handler
 * @param isActive - Whether the click outside detection is active
 * @param onClickOutside - Handler to call when a click outside is detected
 */
export const useClickOutside = (
  refs: RefObject<HTMLElement | null>[],
  isActive: boolean,
  onClickOutside: () => void,
): void => {
  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (event: MouseEvent) => {
      const clickedOutsideAll = refs.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node),
      );

      if (clickedOutsideAll) {
        onClickOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [refs, isActive, onClickOutside]);
};
